import anime from 'animejs';
import * as GLOBALS from '../globals';
let inView = require('in-view');

export default function InitAnimations() {
	const reducedMotionMatch = window.matchMedia('(prefers-reduced-motion: reduce)');

	if (reducedMotionMatch && !reducedMotionMatch.matches) {
		InitHeroAnimations();
	}
}

function InitHeroAnimations() {
	const timeline = anime.timeline();

	const heroTitle = document.querySelector('header .hero-title');
	
	timeline
			.add({
				targets: heroTitle,
				opacity: [0, 1],
				easing: 'cubicBezier(.8, .75, .42, 1)',
				duration: 500
			});

	const heroWrapper = document.querySelector('header .hero-wrapper');
	if (heroWrapper === null) return;

	timeline
			.add({
				targets: heroWrapper,
				opacity: [0, 1],
				translateX: [heroWrapper.getBoundingClientRect().width * .25, 0],
				easing: 'cubicBezier(.8, .75, .42, 1)',
				duration: 500
			});
}
